import { useCallback } from "react";

export function useCloseAndBlur(close: () => void) {
    return useCallback(() => {
        close();
        // UI controls restore focus to trigger on close; blur after that step.
        requestAnimationFrame(() => {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement) {
                activeElement.blur();
            }
        });
    }, [close]);
}
